import { CrudPage } from '@restavo/crud';
import React from 'react';
import { employeeDayOffPage } from 'src/features/employeeDayOff';

const EmployeeDayOff = React.memo(() => <CrudPage {...employeeDayOffPage} />);

export default EmployeeDayOff;
